import Box from "@mui/material/Box";
import { styled } from "@mui/system";
import { alpha } from '@mui/material'
import { specialFont } from "../../Infrastructure/Theme/fontFamily";

export const educatorDashboardSX = {
    mainBox: {
        px: { xs: 2, sm: 2, md: 5 },
        pt: 5,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row' },
        gap: 2
    },

    leftWrapper: {
        width: { xs: "100%", md: "18%" },
        height: { md: "auto" }
    },

    tabText: {
        cursor: "pointer"
    },

    rightBox: {
        overflowY: 'scroll',
        '::-webkit-scrollbar': {
            display: 'none'
        },
        pt: { xs: 5, sm: 0 },
        minHeight: '90vh'
    },

    pendingContainer: {
        height: "100vh",
        display: "flex",
        gap: 4,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: 'justify',
        maxWidth: '1500px',
        mx: "auto",
        px: { xs: 2, sm: 5, md: 30 },
        py: 5
    },

    pendingTitle: {
        fontSize: { xs: 28, md: 36 },
        textAlign: 'center',
        fontWeight: 'bold',
        fontFamily: specialFont
    },

    pendingText: {
        fontSize: { xs: 18, md: 24 }
    }
}


export const educatorCoursesSx = {
    headerBox: {
        display: 'flex',
        gap: 8,
        mb: 5
    },
    headerTitle: {
        display: { xs: 'none', md: 'block' },
    },
    loaderBox: {
        height: '80vh'
    },
    emptyText: {
        mt: { xs: 5 }
    }
}
export const educatorClassesSx = {
    mainBox: {
        width: '100%',
        pb: 20
    },

    modalBox: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        p: { xs: 2, sm: 3 },
        width: { xs: '95%', sm: '80%', md: 600 },
        maxWidth: '95%',
        maxHeight: '80vh',
        overflowY: 'auto'
    },

    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2
    },

    modalTitle: {
        fontWeight: 'bold'
    },

    copyButton: {
        textTransform: 'none',
        borderRadius: '16px',
        fontSize: '0.75rem',
        padding: '4px 10px'
    },

    table: {
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: 1
    },

    tableHeaderRow: {
        backgroundColor: 'primary.main'
    },

    tableHeaderCell: {
        color: 'white',
        fontWeight: 'bold',
        fontSize: '0.8rem'
    },

    tableRow: {
        '&:nth-of-type(odd)': { backgroundColor: 'grey.100' },
        '&:hover': { backgroundColor: 'grey.200' },
        transition: '0.2s'
    },

    tableCell: {
        fontSize: '0.8rem',
        padding: '6px 12px'
    },

    emptyTableCell: {
        fontSize: '0.8rem'
    },

    backIconWrapper: {
        cursor: 'pointer',
        pb: 2,
        display: 'inline-block'
    },

    pageHeader: {
        display: 'flex',
        gap: 8,
        mb: 5
    },

    classesTitle: {
        display: { xs: 'none', md: 'block' }
    },

    tabsWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        my: 4
    },

    tabItemWrapper: {
        mx: 2,
        mb: { xs: 1, sm: 0 },
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
    },

    tabText: {
        cursor: 'pointer',
        pl: 1,
        pr: 1,
        pb: 2
    },

    tabActive: {
        borderBottom: '4px solid'
    },

    tabInactive: {
        borderBottom: '4px solid #ccc'
    },

    tabCountBadge: {
        backgroundColor: '#000080',
        borderRadius: '50%',
        width: 25,
        height: 25,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ml: 1,
        position: 'relative',
        top: -20,
        left: -10
    },

    tabCountText: {
        color: 'white'
    },

    classesScrollWrapper: {
        width: '100%',
        overflowY: 'scroll',
        '::-webkit-scrollbar': {
            display: 'none'
        }
    },

    classItemsWrapper: {
        display: 'flex',
        justifyContent: { xs: 'center', sm: 'flex-start' },
        gap: 4,
        flexWrap: 'wrap'
    },

    emptyStateWrapper: {
        display: 'flex',
        width: '100%'
    },

    emptyStateText: {
        mt: { xs: 5, md: 0 }
    }
}

export const earningsSx = {
    earningsTableSx: {
        headerCell: {
            py: 2,
        },
        bodyCell: {
            py: 2,
        },
    },
    loadingText: {
        mt: 2,
    },
    stripeErrorTitle: {
        mt: 2,
        fontWeight: 'bold',
        textAlign: 'center'
    },
    stripeErrorDescription: {
        mt: 1,
        maxWidth: 400,
        textAlign: 'center',
    },
    statLabel: {
        fontSize: 16,
        fontWeight: 600
    },

    statValue: {
        fontSize: 24,
        fontWeight: 900
    },

    pendingText: {
        fontSize: 12,
        color: 'grey'
    },

    stripeDetailsBox: {
        display: 'flex',
        gap: 4
    },

    stripeDetailsIcon: {
        cursor: 'pointer',
        mb: { xs: 2, sm: 5 },
        mt: 1
    },

    stripeDetailsTextBox: {
        mb: 5
    },

    stripeDetailsText: {
        fontSize: { xs: 28, md: '40px' }
    },

    pageHeaderBox: {
        display: 'flex',
        gap: 8,
        mb: 5
    },

    loadingWrapper: {
        width: '100%',
        height: '50vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },

    stripeErrorWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'auto',
        p: 3
    },

    earningsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 5
    },

    earningsCard: {
        p: { xs: 2, sm: 5 },
        borderRadius: '15px',
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
        display: 'flex',
        flexDirection: 'column',
        gap: 8
    },

    earningsTopRow: {
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 5, sm: 0 },
        justifyContent: 'space-between'
    },

    earningsStatsGroup: {
        display: 'flex',
        justifyContent: { xs: 'space-between', sm: 'flex-start' },
        gap: 3
    },

    earningsStatItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1
    },

    stripeDetailsButton: {
        width: { xs: '100%', sm: '300px' },
        borderRadius: '30px',
        height: '50px'
    },

    recentEnrollmentsTitle: {
        py: 2,
        fontSize: 16,
        fontWeight: 600
    },

    transactionsLoader: {
        width: '100%',
        height: '50vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    emptyTransactionsText: {
        my: 4,
        textAlign: "center"
    },

    onboardingCard: {
        borderRadius: '15px',
        border: '3px solid grey',
        p: { xs: 2, sm: 5 },
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 5
    },

    onboardingText: {
        fontSize: '28px',
        fontWeight: '500'
    },

    stripeImageWrapper: {
        height: 100,
        width: { xs: '100%', sm: 500 },
        position: 'relative',
        overflow: 'hidden'
    },
    onboardingButton: {
        my: 5,
        borderRadius: '30px',
        height: '50px'
    }
}

export const stripeAccountManagementSx = {
    root: {
        gap: 2,
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        flexDirection: "column",
        justifyContent: 'center'
    }
}

export const MainBox = styled(Box)(({ theme }) => ({
    width: "100%",
    minHeight: "100vh",
    height: "auto"
}));

export const RightBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "80%",
    paddingBottom: "20px",
    [theme.breakpoints.down('sm')]: {
        justifyContent: "center",
        alignItems: "center"
    },
    [theme.breakpoints.down('md')]: {
        width: "100%",
    },
}));

export const LeftBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    minheight: "auto",
    gap: "14px",
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    borderLeft: "3px solid grey",
    marginTop: "100px",
    [theme.breakpoints.down('md')]: {
        marginTop: '0',
        display: 'flex',
        flexDirection: 'row',
        border: '0px',
        paddingLeft: 0,
        flexWrap: "wrap",
    },
}));

export const CoursesBox = styled(Box)(({ theme }) => ({
    gap: 20,
    display: "flex",
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'center'
    }
}))

export const ClassCardBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    borderRadius: "30px",
    border: "2px solid grey",
    boxSizing: "border-box",
    padding: theme.spacing(2),
    background: 'white',
    width: "300px",
    // Hide scrollbar but allow scrolling
    '&::-webkit-scrollbar': {
        display: 'none', // hide scrollbar in webkit browsers
    },
    '-ms-overflow-style': 'none',  // hide scrollbar in IE and Edge
    'scrollbar-width': 'none',     // hide scrollbar in Firefox
}));

export const ClassScheduleBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    minHeight: "137px",
    maxHeight: "200px",
    boxSizing: "border-box",
    width: '90%',
    background: 'white',
    [theme.breakpoints.down('xs')]: {
        width: "90%",
    },
    [theme.breakpoints.up('md')]: {
        width: "auto",
    },
    // Hide scrollbar but allow scrolling
    '&::-webkit-scrollbar': {
        display: 'none', // hide scrollbar in webkit browsers
    },
    '-ms-overflow-style': 'none',  // hide scrollbar in IE and Edge
    'scrollbar-width': 'none',     // hide scrollbar in Firefox
}));

export const CourseCard = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "30px",
    border: "2px solid grey",
    width: "250px",
    minHeight: "170px",
    overflow: "hidden"
}));

export const ClassCard = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "30px",
    border: "2px solid grey",
    minWidth: "300px",
    minHeight: "160px",
    height: 'auto',
    padding: theme.spacing(2),
    width: '90%',
    [theme.breakpoints.down('xs')]: {
        width: "90%",
    },
    [theme.breakpoints.up('md')]: {
        width: "auto",
    },
}));